import { createAsyncThunk } from '@reduxjs/toolkit';
import notify from '../../utils/notify';

//Include Both Helper File with needed methods
import {
  getFolders as getFoldersApi,
  addNewFolder as addNewFolderApi,
  updateFolder as updateFolderApi,
  deleteFolder as deleteFolderApi,
  getFiles as getFilesApi,
  addNewFile as addNewFileApi,
  updateFile as updateFileApi,
  deleteFile as deleteFileApi,
} from '../../helpers/fakebackend_helper';

export const getFolders = createAsyncThunk(
  'fileManager/getFolders',
  async () => {
    try {
      const response = getFoldersApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const addNewFolder = createAsyncThunk(
  'fileManager/addNewFolder',
  async folder => {
    try {
      const response = addNewFolderApi(folder);
      notify.success('Folder added successfully.');
      return response;
    } catch (error) {
      notify.apiError(error, 'add folder');
      return error;
    }
  }
);

export const updateFolder = createAsyncThunk(
  'fileManager/updateFolder',
  async folder => {
    try {
      const response = updateFolderApi(folder);
      notify.success('Folder updated successfully.');
      return response;
    } catch (error) {
      notify.apiError(error, 'update folder');
      return error;
    }
  }
);

export const deleteFolder = createAsyncThunk(
  'fileManager/deleteFolder',
  async folder => {
    try {
      const response = deleteFolderApi(folder);
      notify.success('Order deleted successfully.');
      return response;
    } catch (error) {
      notify.apiError(error, 'delete order');
      return error;
    }
  }
);

export const getFiles = createAsyncThunk('fileManager/getFiles', async () => {
  try {
    const response = getFilesApi();
    return response;
  } catch (error) {
    return error;
  }
});

export const addNewFile = createAsyncThunk(
  'fileManager/addNewFile',
  async file => {
    try {
      const response = addNewFileApi(file);
      notify.success('File added successfully.');
      return response;
    } catch (error) {
      notify.apiError(error, 'add file');
      return error;
    }
  }
);

export const updateFile = createAsyncThunk(
  'fileManager/updateFile',
  async file => {
    try {
      const response = updateFileApi(file);
      notify.success('File updated successfully.');
      return response;
    } catch (error) {
      notify.apiError(error, 'update file');
      return error;
    }
  }
);

export const deleteFile = createAsyncThunk(
  'fileManager/deleteFile',
  async file => {
    try {
      const response = deleteFileApi(file);
      notify.success('File deleted successfully.');
      return response;
    } catch (error) {
      notify.apiError(error, 'delete file');
      return error;
    }
  }
);
